import React from 'react';

export default function CreatorIcon({ fill = '#1C274C', stroke = '#FFF', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="40px" height="40px" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                style={{ fill: '#2C3E50' }}
                d="M260.741,234.453h-60.68c-9.22,0-16.695-7.475-16.695-16.695v-59.872
                c0-9.22,7.475-16.695,16.695-16.695h60.68c9.22,0,16.695,7.475,16.695,16.695v59.872
                C277.436,226.978,269.961,234.453,260.741,234.453z"
            />
            <path
                style={{ fill: '#6A82A1' }}
                d="M108.378,462.492C48.618,462.492,0,413.874,0,354.114V157.886C0,98.126,48.618,49.508,108.378,49.508
                s108.378,48.617,108.378,108.377v196.229C216.756,413.874,168.138,462.492,108.378,462.492z"
            />
            <path
                style={{ fill: '#36495E' }}
                d="M108.378,49.508v412.982c59.76,0,108.378-48.617,108.378-108.377V157.886
                C216.756,98.126,168.138,49.508,108.378,49.508z"
            />
            <path
                style={{ fill: '#FFE57F' }}
                d="M108.378,214.255c-27.211,0-49.349-22.138-49.349-49.348c0-27.212,22.138-49.349,49.349-49.349
                s49.349,22.138,49.349,49.349C157.727,192.117,135.589,214.255,108.378,214.255z"
            />
            <circle style={{ fill: '#FF8A80' }} cx="108.377" cy="337.105" r="22.006" />
            <path
                style={{ fill: '#6A82A1' }}
                d="M473.043,296.199H283.001c-21.48,0-38.957-17.476-38.957-38.957V118.401
                c0-21.48,17.476-38.957,38.957-38.957h190.042c21.48,0,38.957,17.476,38.957,38.957v138.843
                C512,278.722,494.524,296.199,473.043,296.199z"
            />
            <path
                style={{ fill: '#FFD740' }}
                d="M108.378,115.556v98.699c27.211,0,49.349-22.138,49.349-49.348
                C157.727,137.695,135.589,115.556,108.378,115.556z"
            />
            <path
                style={{ fill: '#FF5252' }}
                d="M108.378,315.099L108.378,315.099v44.008l0,0c12.152,0,22.003-9.851,22.003-22.003
                C130.381,324.951,120.53,315.099,108.378,315.099z"
            />
            <path
                style={{ fill: '#36495E' }}
                d="M473.043,79.444h-95.021v216.756h95.021c21.48,0,38.957-17.476,38.957-38.957V118.401
                C512,96.92,494.524,79.444,473.043,79.444z"
            />
        </svg>
    );
}
